import { getObjectSelectedValue } from "./workWithObjectEntity";
import { BOOL_ENTITY_TYPE, isBoolEntityChecked } from "./boolEntityField";
import { normalizeEntityList } from "./workWithEntities";

export const VISIBILITY_CONDITION_SOURCE_TYPES = ["Текст", "Список", "Дата", "Объект", BOOL_ENTITY_TYPE] as const;

export type EntityShowWhen = {
    fieldKeyword: string,
    value: string,
}

export function entityHasShowWhen(entity: any): boolean {
    return !!(entity?.showWhen?.fieldKeyword?.trim());
}

export function getEntityByKeywordFromList(entities: any[], keyword: string): any | undefined {
    if (!keyword || !Array.isArray(entities)) {
        return undefined;
    }
    return entities.find((entity: any) => entity.keyword === keyword);
}

export function getEntityConditionValue(entity: any): string {
    if (!entity) {
        return "";
    }

    if (entity.type === BOOL_ENTITY_TYPE) {
        return isBoolEntityChecked(entity.value) ? "да" : "нет";
    }

    if (entity.type === "Объект") {
        const selected = getObjectSelectedValue(entity);
        if (!selected) {
            return (entity.value ?? "").toString().trim();
        }
        const searchField = entity.objectSearchField;
        if (searchField && searchField !== "id") {
            const fieldEntity = selected.entities?.find((inner: any) => inner.keyword === searchField);
            if (fieldEntity?.value) {
                return fieldEntity.value.toString().trim();
            }
        }
        return (selected.value ?? entity.value ?? "").toString().trim();
    }

    return (entity.value ?? "").toString().trim();
}

export function isEntityVisible(entity: any, allEntities: any[]): boolean {
    if (!entityHasShowWhen(entity)) {
        return true;
    }

    const condition = entity.showWhen;
    const sourceEntity = getEntityByKeywordFromList(allEntities, condition.fieldKeyword);
    if (!sourceEntity) {
        return false;
    }

    const actual = getEntityConditionValue(sourceEntity);
    const expected = (condition.value ?? "").toString().trim();
    return actual === expected;
}

export function normalizeVisibilityConditionSourceType(type: string | undefined): string {
    if (!type || !type.trim()) {
        return "Текст";
    }
    return type;
}

export function isVisibilityConditionSourceEntity(entity: any): boolean {
    const type = normalizeVisibilityConditionSourceType(entity?.type);
    return (VISIBILITY_CONDITION_SOURCE_TYPES as readonly string[]).includes(type);
}

export function getVisibilityConditionSourceEntities(entities: any[], excludeKeyword?: string): any[] {
    const excluded = (excludeKeyword ?? "").trim();
    return (entities ?? []).filter((entity: any) => {
        const keyword = (entity?.keyword ?? "").trim();
        if (!keyword) {
            return false;
        }
        return isVisibilityConditionSourceEntity(entity) && keyword !== excluded;
    });
}

export function getVisibilityConditionValueOptions(sourceEntity: any): string[] {
    if (!sourceEntity) {
        return [];
    }

    const sourceType = normalizeVisibilityConditionSourceType(sourceEntity.type);

    if (sourceType === BOOL_ENTITY_TYPE) {
        return ["да", "нет"];
    }

    if (sourceType === "Список") {
        return normalizeEntityList(sourceEntity.list).filter((value: string) => (value ?? "").length > 0);
    }

    if (sourceType === "Объект") {
        const values = sourceEntity.values ?? [];
        const searchField = sourceEntity.objectSearchField;
        return values.map((objectValue: any) => {
            if (!searchField || searchField === "id") {
                return objectValue.value ?? "";
            }
            const fieldEntity = objectValue.entities?.find((inner: any) => inner.keyword === searchField);
            return fieldEntity?.value ?? objectValue.value ?? "";
        }).filter((value: string) => (value ?? "").length > 0);
    }

    return [];
}
